<template>
	<div class="reservas-barco-page">
		<div v-if="loadingInicial" style="text-align: center; padding: 2rem;" v-loading="true" element-loading-text="Cargando...">
			<p style="font-size: 1.1rem; margin-top: 3rem;">Cargando...</p>
		</div>

		<div class="reserva-container" v-else-if="reserva.id">
			<div class="reserva-header">
				<div class="header-row">
					<div class="header-field">
						<label>BARCO:</label>
						<el-select
							v-if="puedeEditarCabecera"
							v-model="reserva.barcoId"
							size="small"
							placeholder="Seleccione barco"
							filterable
							style="width: 100%;"
							:loading="loadingCatalogos"
							@change="onChangeBarco"
						>
							<el-option
								v-for="item in listaBarcos"
								:key="item.id"
								:label="item.nombre"
								:value="item.id"
							/>
						</el-select>
						<el-input v-else v-model="reserva.barcoNombre" size="small" :disabled="true" readonly />
					</div>
					<div class="header-field">
						<label>ALMACÉN:</label>
						<el-select
							v-if="puedeEditarCabecera"
							v-model="reserva.almacenId"
							size="small"
							placeholder="Seleccione almacén"
							filterable
							style="width: 100%;"
							:loading="loadingCatalogos"
							@change="onChangeAlmacen"
						>
							<el-option
								v-for="item in listaAlmacenes"
								:key="item.id"
								:label="item.nombre"
								:value="item.id"
							/>
						</el-select>
						<el-input v-else v-model="reserva.almacenNombre" size="small" :disabled="true" readonly />
					</div>
					<div class="header-field header-title">
						<h2>RESERVA DE BARCO</h2>
						<el-tag size="mini" :type="estadoTagType">{{ estadoLabel }}</el-tag>
					</div>
					<div class="header-field">
						<label>FECHA APERTURA:</label>
						<el-input :value="formatFechaVisual(reserva.fechaApertura)" size="small" :disabled="true" readonly />
					</div>
					<div class="header-field">
						<label>FECHA RESERVA:</label>
						<el-input :value="formatFechaVisual(reserva.fechaReserva)" size="small" :disabled="true" readonly />
					</div>
					<div class="header-field">
						<label>FECHA RECOGIDA:</label>
						<el-input :value="formatFechaVisual(reserva.fechaRecogida)" size="small" :disabled="true" readonly />
					</div>
				</div>

				<div class="reserva-actions">
					<div class="reserva-actions-left" v-if="puedeAgregarLineas">
						<el-autocomplete
							v-model="buscadorArticulo"
							:fetch-suggestions="buscarArticulosMaestro"
							placeholder="Buscar artículo del maestro..."
							size="small"
							value-key="DESCRIPCION"
							@select="seleccionarArticuloMaestro"
							style="width: 100%; max-width: 700px;"
						>
							<template slot-scope="{ item }">
								<div><strong>{{ item.CODIGO }}</strong> - {{ item.DESCRIPCION }}</div>
							</template>
						</el-autocomplete>
					</div>
					<div class="reserva-actions-right">
						<el-button v-if="mostrarGuardar" type="primary" @click="guardarReserva">Guardar</el-button>
						<el-button v-if="mostrarReservar" type="success" @click="reservar">Reservar</el-button>
						<el-button v-if="mostrarConfirmarRecogida" type="warning" @click="confirmarRecogida">Confirmar Recogida</el-button>
					</div>
				</div>
			</div>

			<div class="reserva-table-container">
				<div class="table-header">
					<div class="col-codigo">CÓDIGO</div>
					<div class="col-descripcion">DESCRIPCIÓN</div>
					<div class="col-formato">FORMATO</div>
					<div class="col-cant-reservada">CANT. RESERVADA</div>
					<div class="col-cant-recogida">CANT. RECOGIDA</div>
					<div class="col-acciones">ACCIONES</div>
				</div>

				<div
					v-for="(linea, index) in lineas"
					:key="linea.id || `${linea.idArticulo}-${index}`"
					class="table-row"
					:data-linea="`rb-${linea.idArticulo || index}`"
				>
					<div class="col-codigo">{{ linea.codigo || '-' }}</div>
					<div class="col-descripcion">{{ linea.descripcion || '-' }}</div>
					<div class="col-formato">
						<el-select
							v-if="getOpcionesFormato(linea).length > 1"
							v-model="linea.formato"
							size="small"
							placeholder="Formato"
							style="width: 100%;"
							:disabled="!puedeEditarFormato"
						>
							<el-option
								v-for="opt in getOpcionesFormato(linea)"
								:key="opt.value"
								:label="opt.label"
								:value="opt.value"
							/>
						</el-select>
						<span v-else>{{ (getOpcionesFormato(linea)[0] && getOpcionesFormato(linea)[0].label) || linea.formato || '-' }}</span>
					</div>
					<div class="col-cant-reservada">
						<el-input v-model="linea.cantidadReservada" size="small" type="number" :min="0" :disabled="!puedeEditarCantidadReservada" />
					</div>
					<div class="col-cant-recogida">
						<el-input v-model="linea.cantidadRecogida" size="small" type="number" :min="0" :disabled="!puedeEditarCantidadRecogida" />
					</div>
					<div class="col-acciones">
						<el-button
							v-if="puedeEliminarLineas"
							type="danger"
							size="mini"
							icon="el-icon-delete"
							@click="confirmarEliminarLinea(index)"
						>
							Eliminar
						</el-button>
					</div>
				</div>
			</div>
		</div>

		<div v-else style="padding: 20px;">
			<el-alert title="No se recibió el id de la reserva" type="error" :closable="false" />
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import { getUrl } from '@/helpers/api'

export default {
	name: 'ReservasBarco',
	props: {
		id: [String, Number]
	},
	data() {
		return {
			loadingInicial: true,
			loadingCatalogos: false,
			buscadorArticulo: '',
			listaBarcos: [],
			listaAlmacenes: [],
			reserva: {
				id: null,
				barcoId: null,
				barcoNombre: '',
				almacenId: null,
				almacenNombre: '',
				fechaApertura: '',
				fechaReserva: '',
				fechaRecogida: '',
				estado: 1
			},
			lineas: []
		}
	},
	computed: {
		estadoActual() {
			const n = Number(this.reserva.estado)
			if (n === 2 || n === 3) return n
			return 1
		},
		estadoLabel() {
			if (this.estadoActual === 1) return 'Abierta'
			if (this.estadoActual === 2) return 'Reservada'
			return 'Histórico'
		},
		estadoTagType() {
			if (this.estadoActual === 1) return 'info'
			if (this.estadoActual === 2) return 'warning'
			return 'success'
		},
		puedeEditarCabecera() { return this.estadoActual === 1 },
		puedeAgregarLineas() { return this.estadoActual === 1 || this.estadoActual === 2 },
		puedeEditarFormato() { return this.estadoActual === 1 || this.estadoActual === 2 },
		puedeEditarCantidadReservada() { return this.estadoActual === 1 },
		puedeEditarCantidadRecogida() { return this.estadoActual === 2 },
		puedeEliminarLineas() { return this.estadoActual === 1 || this.estadoActual === 2 },
		mostrarGuardar() { return this.estadoActual === 1 || this.estadoActual === 2 },
		mostrarReservar() { return this.estadoActual === 1 },
		mostrarConfirmarRecogida() { return this.estadoActual === 2 }
	},
	async created() {
		const idProp = this.id != null && this.id !== '' ? Number(this.id) : null
		const idRuta = (this.$route && this.$route.params && this.$route.params.id) ? Number(this.$route.params.id) : null
		const idInicial = idProp || idRuta
		if (!idInicial) {
			this.$message.error('No se recibió el id de la reserva')
			this.loadingInicial = false
			return
		}
		await this.cargarReservaSeleccionada(idInicial)
		this.loadingInicial = false
	},
	watch: {
		id: {
			immediate: false,
			async handler(val) {
				const n = val != null && val !== '' ? Number(val) : null
				if (!n || n === Number(this.reserva && this.reserva.id)) return
				this.loadingInicial = true
				await this.cargarReservaSeleccionada(n)
				this.loadingInicial = false
			}
		}
	},
	methods: {
		async cargarReservaSeleccionada(reservaId) {
			try {
				const endpoints = getUrl()
				if (!endpoints) {
					this.$message.error('Error de configuración')
					return
				}
				const response = await axios.post(
					`${endpoints.backend}entidad/reservas_barco/buscador/obtenerReserva`,
					{ id: reservaId }
				)
				if (!response.data || !response.data.cabecera) {
					this.$message.error('Error al cargar la reserva')
					return
				}
				const cab = response.data.cabecera
				this.reserva.id = response.data.id || reservaId
				this.reserva.barcoId = cab.barcoId || cab.buqueId || null
				this.reserva.barcoNombre = cab.barco || cab.buque || ''
				this.reserva.almacenId = cab.almacenId || null
				this.reserva.almacenNombre = cab.almacen || ''
				this.reserva.fechaApertura = cab.fechaApertura || ''
				this.reserva.fechaReserva = cab.fechaReserva || ''
				this.reserva.fechaRecogida = cab.fechaRecogida || ''
				this.reserva.estado = Number(response.data.estado || cab.estado || 1)

				const lineasResp = Array.isArray(response.data.lineas) ? response.data.lineas : []
				this.lineas = lineasResp.map(l => ({
					id: l.id || null,
					idArticulo: l.idArticulo || l.IDARTICULOS || null,
					codigo: l.codigo || l.CODIGO || '',
					descripcion: l.descripcion || l.DESCRIPCION || '',
					unidadBase: l.unidadBase || l.UNIDAD || 'Uds',
					articulo_conversion: Array.isArray(l.articulo_conversion) ? l.articulo_conversion : (Array.isArray(l.ARTICULO_CONVERSION) ? l.ARTICULO_CONVERSION : []),
					formato: l.formato || l.unidad || l.UNIDAD || 'Uds',
					cantidadReservada: this.getNumeroSeguro(l.cantidadReservada, l.cantidad_reservada),
					cantidadRecogida: this.getNumeroSeguro(l.cantidadRecogida, l.cantidad_recogida)
				}))
				if (this.puedeEditarCabecera) await this.cargarCatalogosCabecera()
			} catch (error) {
				console.error('Error al cargar reserva:', error)
				this.$message.error('Error al cargar la reserva seleccionada')
			}
		},
		getNumeroSeguro(v1, v2) {
			const value = (v1 !== undefined && v1 !== null) ? v1 : v2
			const n = Number(value)
			return isNaN(n) ? 0 : n
		},
		async cargarCatalogosCabecera() {
			try {
				this.loadingCatalogos = true
				await Promise.all([this.cargarListaBarcos(), this.cargarListaAlmacenes()])
			} finally {
				this.loadingCatalogos = false
			}
		},
		async cargarListaBarcos() {
			try {
				const endpoints = getUrl()
				if (!endpoints) return
				const response = await axios.post(`${endpoints.backend}entidad/destinos/buscador/listarDestinos`, {})
				const data = Array.isArray(response.data) ? response.data : (response.data && Array.isArray(response.data.data) ? response.data.data : [])
				this.listaBarcos = data.map(d => ({
					id: d.IDDESTINOS || d.id || d.buqueId,
					nombre: d.DESTINO || d.buque || d.nombre || ''
				})).filter(d => d.id)
				if (!this.reserva.barcoNombre && this.reserva.barcoId) this.onChangeBarco(this.reserva.barcoId)
			} catch (e) {
				this.listaBarcos = []
				this.$message.warning('No se pudo cargar la lista de barcos')
			}
		},
		async cargarListaAlmacenes() {
			const endpoints = getUrl()
			if (!endpoints) return
			const intents = [
				`${endpoints.backend}entidad/almacenes/buscador/listarAlmacenes`,
				`${endpoints.backend}entidad/almacen/buscador/listarAlmacenes`
			]
			for (let i = 0; i < intents.length; i++) {
				try {
					const response = await axios.post(intents[i], {})
					const data = Array.isArray(response.data) ? response.data : (response.data && Array.isArray(response.data.data) ? response.data.data : [])
					this.listaAlmacenes = data.map(a => ({
						id: a.IDALMACENES || a.id || a.almacenId,
						nombre: a.ALMACEN || a.almacen || a.nombre || ''
					})).filter(a => a.id)
					if (!this.reserva.almacenNombre && this.reserva.almacenId) this.onChangeAlmacen(this.reserva.almacenId)
					return
				} catch (e) {
					// probar siguiente endpoint
				}
			}
			this.listaAlmacenes = []
			this.$message.warning('No se pudo cargar la lista de almacenes')
		},
		onChangeBarco(value) {
			const item = this.listaBarcos.find(x => Number(x.id) === Number(value))
			this.reserva.barcoNombre = item ? item.nombre : ''
		},
		onChangeAlmacen(value) {
			const item = this.listaAlmacenes.find(x => Number(x.id) === Number(value))
			this.reserva.almacenNombre = item ? item.nombre : ''
		},
		async buscarArticulosMaestro(query, callback) {
			if (!this.puedeAgregarLineas) {
				callback([])
				return
			}
			try {
				const endpoints = getUrl()
				if (!endpoints) {
					callback([])
					return
				}
				const payload = {}
				if (query && query.trim()) payload.descripcion = query.trim()
				let response = null
				try {
					response = await axios.post(`${endpoints.backend}entidad/articulos/buscador/listarArticulos`, payload)
				} catch (e) {
					// Fallback por compatibilidad con instalaciones sin endpoint global
					response = await axios.post(`${endpoints.backend}entidad/articulos/buscador/listarArticulosSeccion`, payload)
				}
				let articulos = []
				if (Array.isArray(response.data)) articulos = response.data
				else if (response.data && Array.isArray(response.data.data)) articulos = response.data.data
				callback(articulos.map(a => ({ ...a, value: a.DESCRIPCION || '' })))
			} catch (error) {
				console.error('Error al buscar artículos maestro:', error)
				callback([])
			}
		},
		seleccionarArticuloMaestro(articulo) {
			if (!this.puedeAgregarLineas) return
			const idArticulo = articulo.IDARTICULOS || null
			if (!idArticulo) return
			const existente = this.lineas.find(l => l.idArticulo === idArticulo)
			if (existente) {
				this.$message.info('Ese artículo ya está en la reserva')
				this.$nextTick(() => this.scrollALinea(`rb-${existente.idArticulo}`))
				this.buscadorArticulo = ''
				return
			}
			const unidadBase = articulo.UNIDAD || 'Uds'
			const conversiones = Array.isArray(articulo.articulo_conversion) ? articulo.articulo_conversion : []
			this.lineas.push({
				id: null,
				idArticulo,
				codigo: articulo.CODIGO || '',
				descripcion: articulo.DESCRIPCION || '',
				unidadBase,
				articulo_conversion: conversiones,
				formato: unidadBase,
				cantidadReservada: this.estadoActual === 2 ? 0 : 1,
				cantidadRecogida: 0
			})
			this.buscadorArticulo = ''
			this.$nextTick(() => this.scrollALinea(`rb-${idArticulo}`))
		},
		async confirmarEliminarLinea(index) {
			if (!this.puedeEliminarLineas) return
			const linea = this.lineas[index]
			if (!linea) return
			const textoLinea = [linea.codigo, linea.descripcion].filter(Boolean).join(' - ') || 'línea seleccionada'
			try {
				await this.$confirm(`¿Está seguro de eliminar la línea "${textoLinea}"?`, 'Eliminar línea', {
					confirmButtonText: 'Sí',
					cancelButtonText: 'No',
					type: 'warning'
				})
				this.lineas.splice(index, 1)
				this.$message.success('Línea eliminada')
			} catch (error) {
				if (error !== 'cancel') this.$message.error('No se pudo eliminar la línea')
			}
		},
		getOpcionesFormato(linea) {
			const base = (linea.unidadBase || 'Uds').toString().trim() || 'Uds'
			const opciones = [{ label: base, value: base }]
			;(Array.isArray(linea.articulo_conversion) ? linea.articulo_conversion : []).forEach(c => {
				const conv = ((c && c.CONVERSION) || '').toString().trim()
				if (conv && !opciones.find(o => o.value === conv)) opciones.push({ label: conv, value: conv })
			})
			if (!opciones.find(o => o.value === linea.formato)) opciones.push({ label: linea.formato, value: linea.formato })
			return opciones
		},
		scrollALinea(key) {
			const el = this.$el.querySelector(`[data-linea="${key}"]`)
			if (el && typeof el.scrollIntoView === 'function') el.scrollIntoView({ behavior: 'smooth', block: 'center' })
		},
		async guardarReserva() {
			try {
				if (!this.reserva.id) {
					this.$message.warning('No hay reserva cargada')
					return
				}
				const endpoints = getUrl()
				if (!endpoints) {
					this.$message.error('Error de configuración')
					return
				}
				if (this.puedeEditarCabecera) {
					if (!this.reserva.barcoId) {
						this.$message.warning('Debe seleccionar barco')
						return
					}
					if (!this.reserva.almacenId) {
						this.$message.warning('Debe seleccionar almacén')
						return
					}
				}
				const payload = {
					id: this.reserva.id,
					estado: this.estadoActual,
					cabecera: {
						barcoId: this.reserva.barcoId,
						almacenId: this.reserva.almacenId,
						fechaApertura: this.reserva.fechaApertura,
						fechaReserva: this.reserva.fechaReserva,
						fechaRecogida: this.reserva.fechaRecogida
					},
					lineas: this.lineas.map(l => ({
						id: l.id || null,
						idArticulo: l.idArticulo,
						formato: l.formato,
						cantidadReservada: Number(l.cantidadReservada || 0),
						cantidadRecogida: Number(l.cantidadRecogida || 0)
					}))
				}
				const response = await axios.post(
					`${endpoints.backend}entidad/reservas_barco/buscador/guardarReserva`,
					payload
				)
				if (response.data && !response.data.error) {
					this.$message.success('Reserva guardada correctamente')
					return true
				} else {
					this.$message.error((response.data && response.data.mensaje) ? response.data.mensaje : 'Error al guardar la reserva')
					return false
				}
			} catch (error) {
				console.error('Error al guardar reserva:', error)
				this.$message.error('Error al guardar la reserva')
				return false
			}
		},
		getFechaActualISO() {
			const d = new Date()
			const y = d.getFullYear()
			const m = String(d.getMonth() + 1).padStart(2, '0')
			const day = String(d.getDate()).padStart(2, '0')
			return `${y}-${m}-${day}`
		},
		async solicitarFecha({ titulo, mensaje, confirmButtonText, fechaDefault, fechaMinima }) {
			let fechaSeleccionada = fechaDefault
			const h = this.$createElement
			try {
				let pickerOptions = null
				if (fechaMinima) {
					const minTs = new Date(`${fechaMinima}T00:00:00`).getTime()
					pickerOptions = {
						disabledDate(time) {
							return time.getTime() < minTs
						}
					}
				}
				await this.$msgbox({
					title: titulo,
					message: h('div', [
						h('div', { style: { marginBottom: '10px' } }, mensaje),
						h('el-date-picker', {
							props: {
								value: fechaSeleccionada,
								type: 'date',
								placeholder: 'Seleccione fecha',
								format: 'dd/MM/yyyy',
								'value-format': 'yyyy-MM-dd',
								'picker-options': pickerOptions
							},
							style: { width: '100%' },
							on: {
								input: value => {
									fechaSeleccionada = value
								}
							}
						})
					]),
					showCancelButton: true,
					confirmButtonText: confirmButtonText,
					cancelButtonText: 'Cancelar',
					closeOnClickModal: false
				})
				return (fechaSeleccionada || fechaDefault || '').toString().trim()
			} catch (error) {
				throw error
			}
		},
		formatFechaVisual(fecha) {
			const iso = this.normalizarFechaISO(fecha)
			if (!iso) return ''
			const parts = iso.split('-')
			if (parts.length !== 3) return fecha || ''
			return `${parts[2]}/${parts[1]}/${parts[0]}`
		},
		normalizarFechaISO(fecha) {
			if (!fecha) return ''
			const s = String(fecha).trim()
			if (!s) return ''
			if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s
			if (/^\d{4}-\d{2}-\d{2}T/.test(s)) return s.slice(0, 10)
			if (/^\d{2}\/\d{2}\/\d{4}$/.test(s)) {
				const p = s.split('/')
				return `${p[2]}-${p[1]}-${p[0]}`
			}
			const d = new Date(s)
			if (isNaN(d.getTime())) return ''
			const y = d.getFullYear()
			const m = String(d.getMonth() + 1).padStart(2, '0')
			const day = String(d.getDate()).padStart(2, '0')
			return `${y}-${m}-${day}`
		},
		async reservar() {
			try {
				const guardadoOk = await this.guardarReserva()
				if (!guardadoOk) return
				const fechaDefault = this.getFechaActualISO()
				const fechaReserva = await this.solicitarFecha({
					titulo: 'Reservar',
					mensaje: 'Indique la fecha de reserva',
					confirmButtonText: 'Reservar',
					fechaDefault: fechaDefault
				})
				await this.cambiarEstadoReserva(2, fechaReserva)
			} catch (error) {
				if (error !== 'cancel') {
					this.$message.error('No se pudo completar la reserva')
				}
			}
		},
		async confirmarRecogida() {
			try {
				const guardadoOk = await this.guardarReserva()
				if (!guardadoOk) return
				const fechaDefault = this.getFechaActualISO()
				const fechaRecogida = await this.solicitarFecha({
					titulo: 'Confirmar Recogida',
					mensaje: 'Indique la fecha de recogida',
					confirmButtonText: 'Confirmar',
					fechaDefault: fechaDefault,
					fechaMinima: this.normalizarFechaISO(this.reserva.fechaReserva) || fechaDefault
				})
				const fechaReservaISO = this.normalizarFechaISO(this.reserva.fechaReserva)
				const fechaRecogidaISO = this.normalizarFechaISO(fechaRecogida)
				if (fechaReservaISO && fechaRecogidaISO && fechaRecogidaISO < fechaReservaISO) {
					this.$message.warning('La fecha de recogida debe ser igual o posterior a la fecha de reserva')
					return
				}
				await this.cambiarEstadoReserva(3, fechaRecogida)
			} catch (error) {
				if (error !== 'cancel') {
					this.$message.error('No se pudo confirmar la recogida')
				}
			}
		},
		async cambiarEstadoReserva(estado, fecha) {
			const endpoints = getUrl()
			if (!endpoints) {
				this.$message.error('Error de configuración')
				return
			}
			const payload = { id: this.reserva.id, estado: estado }
			if (estado === 2) payload.fechaReserva = fecha
			if (estado === 3) payload.fechaRecogida = fecha
			const response = await axios.post(
				`${endpoints.backend}entidad/reservas_barco/buscador/cambiarEstadoReserva`,
				payload
			)
			if (response.data && !response.data.error) {
				this.reserva.estado = estado
				if (estado === 2) this.reserva.fechaReserva = fecha
				if (estado === 3) this.reserva.fechaRecogida = fecha
				this.$message.success(estado === 2 ? 'Reserva lanzada correctamente' : 'Recogida confirmada correctamente')
			} else {
				this.$message.error((response.data && response.data.mensaje) ? response.data.mensaje : 'Error al cambiar estado')
			}
		}
	}
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.reservas-barco-page {
	height: 100vh;
	overflow: auto;
	background-color: $--color-background;
}

.reserva-container { padding: 20px; }

.reserva-header {
	background: #fff;
	padding: 15px;
	border-radius: 4px;
	margin-bottom: 20px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header-row {
	display: grid;
	grid-template-columns: 1fr 1fr 2fr 1fr 1fr 1fr;
	gap: 12px;
	margin-bottom: 10px;
	align-items: center;
}

.header-field label {
	display: block;
	font-weight: bold;
	font-size: 0.85rem;
	margin-bottom: 5px;
}

.header-title h2 {
	margin: 0;
	font-size: 1.1rem;
	text-align: center;
	color: $--color-primary;
}

.reserva-actions {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 12px;
	padding-top: 10px;
	border-top: 1px solid #eee;
}

.reserva-actions-left {
	flex: 1;
}

.reserva-actions-right {
	display: flex;
	gap: 8px;
}

.reserva-table-container {
	background: #fff;
	border-radius: 4px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	overflow: auto;
}

.table-header,
.table-row {
	display: grid;
	grid-template-columns: 140px 1fr 180px 170px 170px 130px;
}

.table-header {
	background-color: $--color-main-header;
	color: #fff;
	font-weight: bold;
	font-size: 0.85rem;
	border-bottom: 2px solid $--color-main-header;
}

.table-header > div,
.table-row > div {
	padding: 0.5rem;
	display: flex;
	align-items: center;
	border-right: 1px solid #c0c4cc;
	box-sizing: border-box;
}

.table-header > div:last-child,
.table-row > div:last-child {
	border-right: none;
}

.table-row {
	border-bottom: 1px solid #c0c4cc;
}

@media (max-width: 992px) {
	.header-row {
		grid-template-columns: 1fr 1fr;
	}
	.table-header,
	.table-row {
		grid-template-columns: 120px 1fr 150px 140px 140px 120px;
		font-size: 0.8rem;
	}
}
</style>

